// extracted by mini-css-extract-plugin
export default {"title":"CallListRenderer_title__ffAuz","sup":"CallListRenderer_sup__+1MN5"};